/**
 * Job domain helpers � centralized business rule utilities.
 *
 * These functions encode domain rules that are reused across multiple
 * screens and hooks, ensuring a single source of truth. When a rule
 * changes (e.g. a new terminal status is introduced), only this file
 * needs to be updated.
 */

/**
 * Returns true if a new timesheet entry is permitted for the given job.
 *
 * A timesheet can NOT be added to a job that is in a terminal state
 * (COMPLETED or CLOSED). All other statuses (DRAFT, IN_PROGRESS, etc.)
 * are considered eligible.
 *
 * @param {string | undefined | null} jobStatus - The job's current status string.
 * @returns {boolean}
 */
export function canAddTimesheet(jobStatus) {
  if (!jobStatus) return false
  const status = String(jobStatus).trim().toUpperCase()
  return status !== 'COMPLETED' && status !== 'CLOSED'
}
